import { styled } from "styled-components";

import { dimensionsApiSlice } from "api/dimensionApi.slice";
import { topicsApiSlice } from "api/topicsApi.slice";
import { SectionTitleUnderlined } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";

const StyledEmptyText = styled.p`
  color: ${({ theme }) => theme.colors.fillPrimary};
`;

export const EmptySearchResult = () => {
  const translate = useTranslate();

  const currentSearchQuery = useSelector((state) => state.search.currentSearchQuery);

  const { data: paginatedTopicSearchResults, isFetching: areTopicSearchResultsFetching } =
    topicsApiSlice.endpoints.searchTopics.useInfiniteQuery({ search: currentSearchQuery });
  const { data: paginatedDimensionSearchResults, isFetching: areDimensionSearchResultsFetching } =
    dimensionsApiSlice.endpoints.searchDimensions.useInfiniteQuery({ search: currentSearchQuery });

  const topicSearchResults = paginatedTopicSearchResults?.pages.flat() ?? [];
  const dimensionSearchResults = paginatedDimensionSearchResults?.pages.flat() ?? [];

  const hasResults =
    currentSearchQuery.length > 0 && (dimensionSearchResults?.length > 0 || topicSearchResults?.length > 0);

  const emptyText =
    currentSearchQuery.length <= 0
      ? "app.search.placeholder"
      : areDimensionSearchResultsFetching || areTopicSearchResultsFetching
        ? "app.search.searching"
        : "app.search.results.no_results";

  if (hasResults) return null;

  return (
    <>
      <SectionTitleUnderlined>{translate("app.search.results.title")}</SectionTitleUnderlined>
      <StyledEmptyText>{translate(emptyText)}</StyledEmptyText>
    </>
  );
};
